import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import Grid from "@material-ui/core/Grid";
import Image from "../../../assets";
import CustomButton from "../CustomButton";
import Modal from "@material-ui/core/Modal";
import CustomPaper from "../CustomPaper";
import Color from "../../../utils/Color";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import LoadingOverlay from "../LoadingOverlay";

function getModalStyle() {
  const top = 39;
  const left = 40;
  
  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
   
  };
}

function getMobileModalStyle() {
  const top = 42;
  const left = 50;

  return {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "Fixed",
    overflow: "auto",
    display: "block",
    [theme.breakpoints.up("sm")]: {
      minWidth: 580,
      maxHeight: 630,
    },
    [theme.breakpoints.down("xs")]: {
      //minWidth: 300,
      maxWidth:260,
      marginTop: 20,
      marginBottom: 20,
      maxHeight: 500,
    },
    paddingLeft: 25,
    paddingRight: 10,
    paddingBottom: 25,
    "&:focus": {
      outline: "none",
    },
    '&::-webkit-scrollbar': {
      width: '0.1em'
    },
    
  },
  paperLoading: {
    position: "absolute",
    overflow: "hidden",
    display: "block",
    [theme.breakpoints.up("sm")]: {
      minWidth: 580,
      maxHeight: 550,
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: 300,
      marginTop: 20,
      marginBottom: 20,
      maxHeight: 500,
    },
    paddingLeft: 25,
    paddingRight: 10,
    paddingBottom: 25,
    "&:focus": {
      outline: "none",
    },
  },
  modalTitleStyle: {
    fontSize: "18px",
    ...getFontWeight("800"),
    paddingLeft: 0,
    display:"inline-block"
  },
  buttonTextStyle: {
    paddingRight: 20,
    paddingLeft: 20,
    // minWidth: 80,
    // marginLeft: 10,
    // marginRight: 15,
  },
  okBtnSty:{
   // width:90,
    height:30,
  },
  cancelButtonTextStyle: {
    paddingRight: 20,
    paddingLeft: 20,
    // marginLeft: 10,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    border: "1px solid",
    borderRadius: 8,
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
  },
  closeButtonStyle:{
    "&:hover": {
      cursor: "pointer"
    },
    width:"19px",
    height:"19px"
  }
}));

const CustomModal = ({
  open,
  handleClose,
  modalTitle,
  titlestyle,
  modalComponent,
  submitButtonText,
  handleSubmitButton,
  cancelButtonText,
  handleCancelButton,
  isVisibleCloseButton = true,
  disableBackdropClick = false,
  loading,
  modalDesign,
  isMovieCloseBtn,
  okBtnSty,
  ...props
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.down("xs"));

  const [modalStyle] = React.useState(getModalStyle());
  const [mobileModalStyle] = React.useState(getMobileModalStyle());

  const body = (
    <CustomPaper
      design={loading ?`${classes.paperLoading} ${modalDesign}`: `${classes.paper} ${modalDesign}`}
      style={matchesXS ? mobileModalStyle : modalStyle}
    >
      <Grid container>
        {isVisibleCloseButton ? (
          <Grid item xs={12}>
            <Grid container justify={"flex-end"}>
              <img src={isMovieCloseBtn ? Image.plusB : Image.clear_icon} onClick={handleClose} className={classes.closeButtonStyle}/>
            </Grid>
          </Grid>
        ) : (
          false
        )}
        <Grid
          container
          style={
            isVisibleCloseButton ? { marginBottom: modalTitle ? 30 : 0 } : { paddingTop: 10 }
          }
        >
            <Grid item xs={isVisibleCloseButton ? 10 : 12}>
              <CustomText design={`${classes.modalTitleStyle} ${titlestyle}`}>
                {modalTitle}
              </CustomText>
            </Grid>
        </Grid>
      </Grid>
      {modalComponent}
      <Grid container spacing={2} style={{ marginBottom: 0}}>
      {submitButtonText ? (
        <Grid item style={{width:!okBtnSty ? "": "100%"}}>
          <CustomButton
            title={submitButtonText}
            design={`${classes.buttonTextStyle} ${!okBtnSty ? "":classes.okBtnSty}`}
            onClick={handleSubmitButton}
          />
        </Grid> ) : (false)}

        {cancelButtonText ? (
          <Grid item>
            <CustomButton
              title={cancelButtonText}
              design={classes.cancelButtonTextStyle}
              onClick={handleCancelButton}
            />
          </Grid>
        ) : (
          false
        )}
        
      </Grid>
      
    </CustomPaper>
    
  );

  return (
    <Grid>
      <Modal
        open={open}
        onClose={handleClose}
        disableBackdropClick={disableBackdropClick}
        style={{display:'flex',alignItems:'center',justifyContent:'center'}}
      >
        <div>
        {loading ? <LoadingOverlay loading={true} /> : false}
        {body}
        </div>
        
      </Modal>
      
    </Grid>
  );
};

export default CustomModal;
